<template>
    <bp-directional>
        <div
            class="dropdownMenu"
            :class="{ 'dropdownMenu--open': expanded }"
            v-on="{ focusout }"
        >
            <button
                ref="link"
                :href="href"
                :aria-controls="id"
                :aria-expanded="String(expanded)"
                class="dropdownMenu__button"
                :class="labelClass"
                @click.prevent.stop="click"
            >
                <slot name="link">
                    {{ label }}
                </slot>
                <slot name="button">
                    <svg
                        class="dropdownMenu__icon"
                        viewBox="0 0 24 24"
                        stroke-width="1"
                        stroke="currentColor"
                        fill="none"
                    ><polyline points="6 9 12 15 18 9" /></svg>
                </slot>
            </button>

            <transition :name="transition">
                <div
                    v-if="expanded"
                    :id="id"
                    class="dropdownMenu__shell"
                    @keydown.esc.prevent="close"
                >
                    <div class="dropdownMenu__body">
                        <slot />
                    </div>
                </div>
            </transition>
        </div>
    </bp-directional>
</template>

<script>
import BpDropdown from '../../atoms/dropdown/BpDropdown'

export default {
    mixins: [BpDropdown],
    components: {
        BpDropdown,
    },
    props: {
        href: { required: false },
        transition: { type: String, default: 'dropdownMenu__transition' },
        labelClass: { type: String, default: '' },
    },
    data: () => ({
        expanded: false,
    }),
}
</script>
